import { AppBundle } from 'api/optimalprint-sdk.d';
import React, { FC, useEffect } from 'react';
import { CatalogItem } from 'store/landing/types';
import cn from 'classnames';
import { useLandingPageContext } from 'context/LandingPageContext';
import LPCatalogItem from './LPCatalogItem/LPCatalogItem';
import styles from './LPCatalog.module.scss';
import LpShopifyCatalog from './LpShopifyCatalog/LpShopifyCatalog';

export interface LPCatalogProps {
  name: string;
  defaultSelected?: CatalogItem | null;
  items: CatalogItem[];
  h1Color?: string;
  titleColor?: string;
  titleFontWeight?: string;
  variant?: 'carousel' | 'grid';
}

const LPCatalog: FC<LPCatalogProps> = ({ name, items, variant }) => {
  const { theme, fetchCatalogItemsPrices } = useLandingPageContext();

  useEffect(() => {
    if (items.length > 0) {
      fetchCatalogItemsPrices(items);
    }
  }, []);

  if (theme === 'shopify') {
    return <LpShopifyCatalog title={name} items={items} variant={variant} />;
  }

  return (
    <div className={cn(styles.lpCatalog, styles[`theme-${theme}`])}>
      <h2 className={styles.lpCatalogName} dangerouslySetInnerHTML={{ __html: name }} />
      <div className={styles.lpCatalogItems}>
        {items.map((item) => (
          <LPCatalogItem
            key={item.entryId}
            image={item.productImageUrlDesktop}
            imageMobile={item.productImageUrlMobile}
            name={item.title}
            abstractProduct={item.abstractProduct as AppBundle.Api.Entity.App.V1.IAbstractProduct}
            referenceUrl={item.referenceUrl}
            theme={theme}
            badgeText={item.badgeText}
            badgeTheme={item.badgeTheme}
          />
        ))}
      </div>
    </div>
  );
};

export default LPCatalog;
